import { Achievement } from '../types';

export const achievements: Achievement[] = [
  {
    id: 'govjam-2024',
    name: 'GovJam 2024',
    year: '2024',
    participation: 'مشارك',
    description:
      'شاركت في GovJam 2024، فعالية تصميم وابتكار تركز على تحسين الخدمات الحكومية وتجربة المواطن.',
    externalUrl: '[أضف رابط الفعالية]',
    images: [
      '/images/achievements/govjam-1.png',
      '/images/achievements/govjam-2.png',
    ],
    type: 'event',
  },
  {
    id: 'prince-hussein-award',
    name: 'جائزة الأمير حسين — مسابقة التطبيقات الحكومية',
    year: '[أضف السنة]',
    participation: 'عضو فريق',
    achievement: 'أفضل 5',
    description:
      'شاركت في النسخة الأولى من مسابقة أفضل تطبيق حكومي. حقق فريقنا مكانة ضمن أفضل 5.',
    teamInfo: '[أضف معلومات الفريق]',
    externalUrl: '[أضف رابط المسابقة]',
    images: [
      '/images/achievements/prince-hussein-1.png',
      '/images/achievements/prince-hussein-2.png',
    ],
    type: 'competition',
  },
];
